import { render, staticRenderFns } from "./CreateArchive.vue?vue&type=template&id=0e7f06f4&scoped=true"
import script from "./CreateArchive.vue?vue&type=script&lang=js"
export * from "./CreateArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f06f4",
  null
  
)

export default component.exports